import { Eyebrow, Reveal } from "./Reveal";

const BG_IMAGE =
    "https://images.unsplash.com/photo-1731955407171-89206dce788c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHw0fHxkYXJrJTIwZXhlY3V0aXZlJTIwY2xpbmljJTIwbHV4dXJ5JTIwb2ZmaWNlfGVufDB8fHx8MTc5MDM5NDQ2NXww&ixlib=rb-4.1.0&q=85";

const PORTRAIT_IMAGE =
    "https://images.unsplash.com/photo-1699621106755-4fe40ce95d64?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwxfHxkYXJrJTIwZXhlY3V0aXZlJTIwY2xpbmljJTIwbHV4dXJ5JTIwb2ZmaWNlfGVufDB8fHx8MTc5MDM5NDQ2NXww&ixlib=rb-4.1.0&q=85";

export default function Authority() {
    return (
        <section
            id="autoridade"
            className="relative overflow-hidden border-t border-gold-faint px-6 py-28 lg:px-10 lg:py-36"
            style={{ backgroundColor: "#141414" }}
            data-testid="authority-section"
        >
            <img
                src={BG_IMAGE}
                alt=""
                aria-hidden
                className="absolute right-0 top-0 h-full w-1/2 object-cover opacity-[0.07] grayscale"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#141414] via-[#141414]/95 to-[#141414]/70" />

            <div className="relative mx-auto grid max-w-7xl grid-cols-1 gap-16 lg:grid-cols-12">
                <div className="lg:col-span-5">
                    <Reveal>
                        <Eyebrow>Relatório de Origem · Dossiê #2020</Eyebrow>
                    </Reveal>
                    <Reveal delay={0.08}>
                        <h2 className="mt-7 font-serif text-3xl leading-tight text-white sm:text-4xl lg:text-5xl">
                            A Origem do Olhar{" "}
                            <em className="italic text-gold">Investigativo</em>
                        </h2>
                    </Reveal>
                    <Reveal delay={0.16} className="mt-14 hidden lg:block">
                        <div className="relative max-w-sm">
                            <div className="absolute -left-3 -top-3 h-full w-full border border-gold-faint" />
                            <img
                                src={PORTRAIT_IMAGE}
                                alt="Ambiente executivo onde a primeira investigação ocorreu"
                                className="relative w-full border border-line object-cover grayscale contrast-125"
                                data-testid="authority-image"
                            />
                        </div>
                    </Reveal>
                </div>

                <div className="lg:col-span-7">
                    <Reveal delay={0.1}>
                        <p
                            className="text-lg font-light leading-relaxed text-[#e6e6e6] lg:text-xl"
                            data-testid="authority-story"
                        >
                            Em 2020, uma clínica de saúde falida teria seus equipamentos
                            leiloados. Ao analisar o cenário, o olhar investigativo identificou
                            que o problema não era o equipamento, mas a identidade, o
                            posicionamento e a gestão. Em vez da liquidação, foi orquestrada
                            uma reconstrução completa. A clínica não apenas sobreviveu, como se
                            consolidou. O MasterClaus nasceu dessa experiência:{" "}
                            <em className="font-serif italic text-gold">
                                a certeza de que os dados, quando bem investigados, salvam
                                negócios.
                            </em>
                        </p>
                    </Reveal>

                    <Reveal delay={0.18}>
                        <div className="mt-12 border-l-2 border-gold pl-6" data-testid="authority-signature">
                            <p className="font-display text-lg tracking-[0.15em] text-white">
                                CLAUDIO GABRIEL
                            </p>
                            <p className="mt-2 font-mono text-[11px] uppercase tracking-[0.2em] text-[#888888]">
                                Analista de Inteligência Comercial
                            </p>
                        </div>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
